export default {
    administrators: '管理者',
    administratorsTeam:
        '管理者はすべてのデータが確認でき、会社設定を変更できます。',
    approvalFlowName: '　{{flow.name}}',
    approvalFlowsDeleteConfirm:
        'このグループを利用しているため、下記の書類の承認依頼はキャンセルされます。',
    approvalTemplatesSection: {
        approvalTemplateName: '承認フロー名',
        approvalTemplates: '承認フロー',
        approvalTemplatesSubtitle: 'このグループを含む承認フロー',
    },
    clientSection: {
        clientName: '取引先名',
        clients: '取引先',
        emptyClients: 'このグループの取引先は設定されていません。',
        subtitleClient: 'このグループの取引先',
    },
    deleteGroup: 'グループを削除',
    deletionModalContent: {
        approvalFlowsDeleteConfirm:
            'このグループ・役割を利用しているため、下記の書類の承認依頼はキャンセルされます。',
        deleteGroup:
            'グループを削除いただいても、取引先や関連書類は削除されません。担当グループのない取引先は、メンバー全員に表示されます。 このグループを削除しますか？',
        deleteRole: 'この役割を削除しますか？',
        titleGroup: 'グループを削除',
        titleRole: '役割を削除',
    },
    membersSection: {
        emptyMembersGroup: 'このグループには誰も所属していません。',
        emptyMembersRole: 'この役割のメンバーは設定されていません。',
        memberName: 'メンバー名',
    },
    subtitleGroup:
        '取引先に担当グループを設定すると、取引先や関連書類、レポートが所属メンバーにのみ表示されます。',
    subtitleRole: '各メンバーに役割を割り当てることができます。',
};
